interface Props {
  source: string;
}

/** 첫 줄이 `// language: <lang>` 이면 그 줄을 헤더로 떼고 나머지를 코드로. */
function splitLanguageHeader(source: string): { language: string | null; body: string } {
  const match = source.match(/^\/\/\s*language:\s*([\w+-]+)\s*\r?\n/i);
  if (match) {
    return { language: match[1] ?? null, body: source.slice(match[0].length) };
  }
  return { language: null, body: source };
}

/**
 * 일반 code artifact. PR 3 는 syntax highlight 없음 — 평문 `<pre>` 로 표시.
 * Phase 2 에서 prism / shiki 도입 시 이 컴포넌트만 교체.
 */
export function CodeArtifact({ source }: Props) {
  const { language, body } = splitLanguageHeader(source);
  return (
    <div className="flex h-full flex-col bg-surface">
      {language ? (
        <div className="shrink-0 border-b border-border px-4 py-2 text-xs uppercase tracking-wide text-foreground-muted">
          <span className="font-mono">{language}</span>
        </div>
      ) : null}
      <pre className="flex-1 overflow-auto p-4 font-mono text-xs text-foreground/90 whitespace-pre">
        {body}
      </pre>
    </div>
  );
}
